import axios from 'axios'
import config from './config'

export default axios.create({
  baseURL: config.API_URL,
  headers: {
    'API-Key': 'FC76A766-684A-47E4-B05E-BDE322B2A5BF',
  },
})
